const fonts = ['/media/fonts/audi/font.css'];
const icons = ['/media/scripts/fontawesome/v5.15.4/394cd21ac4.js'];
const css = ['https://cdn.jsdelivr.net/npm/neuicons/css/neu.min.css'];

export default {
  defaultCulture: 'nl',
  fonts: fonts,
  icons: icons,
  css: css
};
